var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{staticClass:"layout-layout",attrs:{"layout":_vm.component.layout,"module":_vm.module,"mode":_vm.mode,"resource":_vm.resource,"context":_vm.context,"translation-prefix":_vm.nestedTranslationPrefix,"layout-path":_vm.newLayoutPath,"brezel-component-id":_vm.component.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }